import { IReportData } from "pages/reports-menu/types";
import CIQClient, { HTTPClientResponse } from "./ciq-client";
import { BASE_URL_WITHOUT_GATEWAY } from "./endpoints";

interface IUpcomingMilestonesHTTPClientResponse extends HTTPClientResponse {
  data?: IReportData;
}

export const getUpcomingMilestonesReport = (
  projectId: string,
  projectToken: string
): Promise<IUpcomingMilestonesHTTPClientResponse> => {
  const config = {
    headers: { Authorization: `Bearer ${projectToken}` }
  };

  return CIQClient.get({
    url: `${BASE_URL_WITHOUT_GATEWAY}/report-engine/reports/upcoming-milestones/project/${projectId}`,
    config
  });
};
